var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return (_vm.isMobile && _vm.item.phone_mp4_video) ||
    _vm.item.desktop_mp4_video
    ? _c(
        "div",
        {
          class: _vm.css,
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c(
            "video",
            {
              staticClass: "hero-homepage__video-media",
              attrs: {
                playsinline: "",
                preload: "auto",
                autoplay: _vm.videoPlaying,
                loop: _vm.item.loop_phone_video || _vm.item.loop_desktop_video,
              },
              domProps: { muted: _vm.videoMuted },
            },
            [
              _c("source", {
                attrs: {
                  src: _vm.isMobile
                    ? _vm.item.phone_mp4_video.url
                    : _vm.item.desktop_mp4_video.url,
                  type: "video/mp4",
                },
              }),
              _vm._v(
                "\n    Sorry, your browser doesn't support embedded videos.\n  "
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "hero-homepage__controls" }, [
            _c(
              "button",
              {
                staticClass: "hero-homepage__sounds-control",
                attrs: {
                  type: "button",
                  "aria-pressed": !_vm.videoMuted,
                  "aria-label": _vm.videoMuted ? "Unmute video" : "Mute video",
                },
                on: {
                  click: _vm.toggleMute,
                  keydown: [
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.toggleMute.apply(null, arguments)
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "space", 32, $event.key, [
                          " ",
                          "Spacebar",
                        ])
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.toggleMute.apply(null, arguments)
                    },
                  ],
                },
              },
              [
                !_vm.videoMuted
                  ? _c(
                      "svg",
                      {
                        attrs: {
                          id: "Sounds_On",
                          "data-name": "Sounds On",
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "30",
                          height: "30",
                          viewBox: "0 0 183.18712 183.18712",
                          "aria-hidden": "true",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M104.17854,35.93975V147.24737a4.03673,4.03673,0,0,1-6.77655,2.96454L73.45155,128.07677a39.57844,39.57844,0,0,0-26.8631-10.51245H29.14833a4.29163,4.29163,0,0,1-4.29163-4.29168V69.91448a4.29163,4.29163,0,0,1,4.29163-4.29169H46.58845a39.57872,39.57872,0,0,0,26.8631-10.51245L97.402,32.97521A4.03673,4.03673,0,0,1,104.17854,35.93975ZM121.897,150.42485a65.73223,65.73223,0,0,0,.00114-117.66322,6.64151,6.64151,0,0,0-5.91662,11.89252,52.44988,52.44988,0,0,1,.00114,93.87818,6.641,6.641,0,1,0,5.91434,11.89252Zm.0627-31.07879a37.2478,37.2478,0,0,0,0-55.50507,6.38018,6.38018,0,1,0-8.65491,9.37653,24.49352,24.49352,0,0,1,0,36.752,6.38018,6.38018,0,0,0,8.65491,9.37653Z",
                          },
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.videoMuted
                  ? _c(
                      "svg",
                      {
                        attrs: {
                          id: "Sounds_Off",
                          "data-name": "Sounds Off",
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "30",
                          height: "30",
                          viewBox: "0 0 183.18712 183.18712",
                          "aria-hidden": "true",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M113.30482,73.21752a6.38018,6.38018,0,1,1,8.65491-9.37653,37.50418,37.50418,0,0,1,12.40436,27.75165,36.74966,36.74966,0,0,1-1.45484,10.25263l-11.3341-11.33405A24.96148,24.96148,0,0,0,113.30482,73.21752Zm2.6767-28.56335a52.48146,52.48146,0,0,1,25.561,65.82446l10.07709,10.07709a65.76794,65.76794,0,0,0-29.7215-87.79413,6.64153,6.64153,0,0,0-5.91662,11.89258Zm-11.803,28.46038V35.93975A4.03673,4.03673,0,0,0,97.402,32.97521L80.06349,48.9995Zm-48.5647-29.97c-.04834-.04828-.08941-.10089-.13592-.15033l-9.14753-9.14752a6.57423,6.57423,0,1,0-9.29687,9.29785L57.8647,63.97576a39.561,39.561,0,0,1-11.27625,1.647H29.14833a4.29163,4.29163,0,0,0-4.29163,4.29169v43.35816a4.29163,4.29163,0,0,0,4.29163,4.29168H46.58845a39.57844,39.57844,0,0,1,26.8631,10.51245L97.402,150.21191a4.03673,4.03673,0,0,0,6.77655-2.96454V110.2896l21.76263,21.76264a52.0402,52.0402,0,0,1-9.95849,6.4801,6.641,6.641,0,1,0,5.91437,11.89252,65.35123,65.35123,0,0,0,13.47412-8.94263l7.84832,7.84833a6.57063,6.57063,0,0,0,9.43329-9.147Z",
                          },
                        }),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "hero-homepage__play-control",
                attrs: {
                  type: "button",
                  "aria-pressed": _vm.videoPlaying,
                  "aria-label": _vm.videoPlaying ? "Pause video" : "Play video",
                },
                on: {
                  click: _vm.togglePlay,
                  keydown: [
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.togglePlay.apply(null, arguments)
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "space", 32, $event.key, [
                          " ",
                          "Spacebar",
                        ])
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.togglePlay.apply(null, arguments)
                    },
                  ],
                },
              },
              [
                !_vm.videoPlaying
                  ? _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "30",
                          height: "30",
                          viewBox: "0 0 24 24",
                          "aria-hidden": "true",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M8 5.14v14l11-7l-11-7z",
                            fill: "currentColor",
                          },
                        }),
                      ]
                    )
                  : _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "30",
                          height: "30",
                          viewBox: "0 0 24 24",
                          "aria-hidden": "true",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M14 19h4V5h-4M6 19h4V5H6v14z",
                            fill: "currentColor",
                          },
                        }),
                      ]
                    ),
              ]
            ),
          ]),
        ]
      )
    : _c("picture", { class: _vm.css }, [
        _c("source", {
          attrs: {
            media: "(min-width: " + _vm.mobileBreakpointWidth + ")",
            srcset: _vm.desktopSrcSet,
            sizes: _vm.desktopSizes,
          },
        }),
        _vm._v(" "),
        _c("source", {
          attrs: { srcset: _vm.mobileSrcSet, sizes: _vm.mobileSizes },
        }),
        _vm._v(" "),
        !_vm.isMobile
          ? _c("img", {
              staticClass: "hero-homepage__picture--image-desktop",
              attrs: {
                loading: _vm.imgLoadingDesktop,
                src: _vm.desktopImage.src,
                width: 1440,
                height: 500,
                role: "presentation",
              },
            })
          : _c("img", {
              staticClass: "hero-homepage__picture--image-mobile",
              attrs: {
                loading: _vm.imgLoadingMobile,
                src: _vm.mobileImage.src,
                width: _vm.mobileImage.width,
                height: _vm.mobileImage.height,
                role: "presentation",
              },
            }),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }